import Hero from "../components/sections/Hero/Hero";
import TrustStrip from "../components/sections/TrustStrip/TrustStrip";
import ServicesOverview from "../components/sections/ServicesOverview/ServicesOverview";
import WebsiteIdeas from "../components/sections/WebsiteIdeas/WebsiteIdeas";
import HowItWorks from "../components/sections/HowItWorks/HowItWorks";
import WhyChooseUs from "../components/sections/WhyChooseUs/WhyChooseUs";
import PricingTeaser from "../components/sections/PricingTeaser/PricingTeaser";
import IndustriesTeaser from "../components/sections/IndustriesTeaser/IndustriesTeaser";
import Testimonials from "../components/sections/Testimonials/Testimonials";
import CtaBand from "../components/sections/CtaBand/CtaBand";

import GettingStarted from "../components/sections/GettingStarted/GettingStarted";

export default function Home() {
  return (
    <>
      <Hero />
      <TrustStrip />
      <ServicesOverview />
      <WebsiteIdeas />
      <HowItWorks bg="muted" />
      <WhyChooseUs />
      <PricingTeaser />
      <IndustriesTeaser />
      <Testimonials />
      <CtaBand />
      <GettingStarted />
    </>
  );
}
